// src/layouts/PenyediaLayout.jsx

import React from "react";
import { AppShell, Title, Text } from "@mantine/core";
import { Routes, Route, Navigate } from "react-router-dom";

// Gunakan komponen UI yang sama agar tampilan konsisten
import { NavbarMinimal } from "../components/NavbarMinimal";
import { HeaderMegaMenu } from "../components/HeaderMegaMenu";
import { FooterSimple } from "../components/FooterSimple";
import PenyediaDashboardPage from "../pages/penyedia/PenyediaDashboardPage";
import DistribusiPenyediaPage from "../pages/penyedia/DistribusiPenyediaPage";
import MenuPenyediaPage from "../pages/penyedia/MenuPenyediaPage";

// --- KOMPONEN HALAMAN DUMMY (SEMENTARA) ---
// Nanti Anda ganti bagian ini dengan import halaman asli Anda
// Contoh: import PenyediaDashboard from "../pages/penyedia/Dashboard";

export default function PenyediaLayout() {
  
  return (
    <AppShell
      padding="md"
      header={{ height: 60 }} 
      navbar={{ width: 80, breakpoint: 'sm' }}
      footer={{ height: 50 }} 
    >
      
      {/* 1. Header Bagian Atas */}
      <AppShell.Header>
        <HeaderMegaMenu />
      </AppShell.Header>
      
      {/* 2. Navbar (Menu Samping) */}
      <AppShell.Navbar p={0}>
        {/* Catatan: Nanti mungkin Anda butuh Navbar khusus untuk Penyedia 
            jika menu ikonnya beda dengan Admin */}
        <NavbarMinimal />
      </AppShell.Navbar>

      {/* 3. Footer Bagian Bawah */}
      <AppShell.Footer p={0}>
        <FooterSimple />
      </AppShell.Footer>

      {/* 4. Konten Utama (Routes khusus Penyedia) */}
      <AppShell.Main>
        <Routes>
          {/* Path ini relatif terhadap /penyedia */}
          {/* Jadi ini akan diakses lewat: /penyedia/dashboard */}
          <Route path="dashboard" element={<PenyediaDashboardPage />} />

          {/* /penyedia/menu */}
          <Route path="/menu" element={<MenuPenyediaPage />} />

          {/* /penyedia/distribusi */}
          <Route path="/distribusi" element={<DistribusiPenyediaPage />} />

          {/* Jika user masuk ke /penyedia saja, lempar ke dashboard */}
          <Route path="*" element={<Navigate to="dashboard" replace />} />
        </Routes>
      </AppShell.Main>

    </AppShell>
  );
}